import StudentLogListSection from "./components/student-log-list-section";

function StudentLogs() {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Student Logs List - Takes remaining height */}
      <div className="h-full">
        <StudentLogListSection />
      </div>
    </div>
  );
}

export default StudentLogs;
